// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"131":"6f1aa6b1","212":"bc6104ee","599":"e89536a8"}[chunkId] + ".js";
};